// extracted by mini-css-extract-plugin
module.exports = {"navArticle":"section-content-module__navArticle___3yE5E"};